/** Traductions centre de notifications (FR / AR) */
export const notificationCenterFr = {
  unreadSingular: 'non lue',
  unreadPlural: 'non lues'
};

export const notificationCenterAr = {
  unreadSingular: 'غير مقروء',
  unreadPlural: 'غير مقروءة'
};
